<template>
    <div class="success-page">
        <div class="success-panel">
            <div class="success-icon">✓</div>
            <h2>
                {{ $i18n.t("subscription.pay_succeed_page_title") }}
            </h2>
            <p class="thank-txt">
                {{ $i18n.t("subscription.pay_succeed_page_thanks") }}
            </p>
            <button class="confirm-btn" @click="goToSubscriptions">
                {{ $i18n.t("subscription.pay_succeed_page_btn_go_to_subscription") }}
            </button>
        </div>
    </div>
</template>

<script>
import { i18n } from "@/plugins/i18n.js";
import { wdConfigData } from "@/service/wd_app_config.js";
export default {
    name: 'PaymentSuccessPage',
    methods: {
        goToSubscriptions() {
            this.$router.push('/subscriptions');
        }
    },
    mounted(){
        i18n.locale = wdConfigData.localLanguage
    }
}
</script>

<style scoped>
.success-panel {
    text-align: center;
    background: white;
    border-radius: 15px;
    padding: 50px 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.success-icon {
    font-size: 35px;
    color: #27ae60;
    margin-bottom: 20px;
}

.thank-txt {
    font-size: 16px;
    color: #555;
    margin-top: 8px;
    margin-bottom: 18px;
}

.confirm-btn {
    width: 100%;
    background: linear-gradient(45deg, #27ae60, #2ecc71);
    color: white;
    border: none;
    padding: 15px 30px;
    border-radius: 35px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;
    margin-top: 15px;
}
</style>